import React, { useState, useEffect } from "react";
import Accordion from "../../hooks/Accordion";

// css
import "./offering-details.css";

const ShareClassFees = () => {
  const [screenSize, getDimension] = useState({
    dynamicWidth: window.innerWidth,
    dynamicHeight: window.innerHeight,
  });
  const [selectedOption, setSelectedOption] = useState("I");

  const setDimension = () => {
    getDimension({
      dynamicWidth: window.innerWidth,
      dynamicHeight: window.innerHeight,
    });
  };

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };

  useEffect(() => {
    window.addEventListener("resize", setDimension);

    return () => {
      window.removeEventListener("resize", setDimension);
    };
  }, [screenSize]);
  return (
    <section className="share-class" id="share-class">
      {screenSize.dynamicWidth < 900 ? (
        <div>
          <h1 className="sub-header t-center">Share Class-Specific Fees</h1>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              margin: "30px 0",
            }}
          >
            <select
              id="select-option"
              value={selectedOption}
              onChange={handleOptionChange}
              className="p-3 border border-black rounded-md w-52"
            >
              <option value="I">Class I</option>
              <option value="D">Class D</option>
              <option value="S">Class S</option>
              <option value="T">Class T</option>
            </select>
          </div>
          {selectedOption === "I" ? (
            <div style={{ borderTop: "1px solid black" }}>
              <Accordion
                title="Availability"
                content="Fee-based (wrap) programs, certain registered investment advisors and other institutional and fiduciary accounts"
              />
              <Accordion
                title="Upfront Selling Commissions"
                content="None"
                sup="6"
              />
              <Accordion
                title="Upfront Dealer Manager Fee"
                sup="6"
                content="None"
              />
              <Accordion
                title="Ongoing Annual Stockholder Servicing Fee"
                sup="6"
                content="None"
              />
            </div>
          ) : null}
          {selectedOption === "D" ? (
            <div style={{ borderTop: "1px solid black" }}>
              <Accordion
                title="Availability"
                content="Fee-based (wrap) programs, certain registered investment advisors and other institutional and fiduciary accounts"
              />
              <Accordion
                title="Upfront Selling Commissions"
                content="Up to 1.5%"
                sup="6"
              />
              <Accordion
                title="Upfront Dealer Manager Fee"
                sup="6"
                content="None"
              />
              <Accordion
                title="Ongoing Annual Stockholder Servicing Fee"
                sup="6"
                content="0.25%"
              />
            </div>
          ) : null}
          {selectedOption === "S" ? (
            <div style={{ borderTop: "1px solid black" }}>
              <Accordion
                title="Availability"
                content="Brokerage and transaction-based accounts"
              />
              <Accordion
                title="Upfront Selling Commissions"
                content="Up to 3.5%"
                sup="6"
              />
              <Accordion
                title="Upfront Dealer Manager Fee"
                sup="6"
                content="None"
              />
              <Accordion
                title="Ongoing Annual Stockholder Servicing Fee"
                sup="6"
                content="0.85%"
              />
            </div>
          ) : null}
          {selectedOption === "T" ? (
            <div style={{ borderTop: "1px solid black" }}>
              <Accordion
                title="Availability"
                content="Brokerage and transaction-based accounts"
              />
              <Accordion
                title="Upfront Selling Commissions"
                content="Up to 3.0%"
                sup="6"
              />
              <Accordion
                title="Upfront Dealer Manager Fee"
                sup="6"
                content="0.50%"
              />
              <Accordion
                title="Ongoing Annual Stockholder Servicing Fee"
                sup="6"
              >
                <span style={{ display: "block" }}>
                  0.65% financial advisor
                </span>
                <span style={{ display: "block" }}>
                  0.20% dealer
                </span>
              </Accordion>
            </div>
          ) : null}
        </div>
      ) : (
        <div style={{ padding: "30px 80px" }}>
          <div className="main-margin">
            <h1 className="sub-header mb-10">Share Class-Specific Fees</h1>
            {/* odtable-header is initially used in the ODTable component. Brought here for consistency */}
            <table className="odtable-header fixed-table table-shadow-main">
              <tr>
                <th className="odtable-tableheader">Fees</th>
                <th colSpan={2} className="odtable-tableheader">
                  <div className="flex-sa">
                    <span>Class I</span>
                    <span>Class D</span>
                  </div>
                </th>
                {/* <th className="odtable-tableheader">
                <span>Class D</span>
              </th> */}
                <th colSpan={2} className="odtable-tableheader">
                  <div className="flex-sa">
                    <span>Class S</span>
                    <span>Class T</span>
                  </div>
                </th>
                {/* <th className="odtable-tableheader">
                <span>Class T</span>
              </th> */}
              </tr>
              <tr>
                <td className="odheader-slim fw-6">Availability</td>
                <td colSpan={2}>
                Fee-based (wrap) programs, certain registered investment advisors and other institutional and fiduciary accounts
                </td>
                <td colSpan={2}>Brokerage and transaction-based accounts</td>
              </tr>
              <tr>
                <td className="fw-6">
                  Upfront Selling Commissions<sup>6</sup>
                </td>
                <td>None</td>
                <td>Up to 1.5%</td>
                <td>Up to 3.5%</td>
                <td>Up to 3.0%</td>
              </tr>
              <tr>
                <td className="fw-6">
                  Upfront Dealer Manager Fee<sup>6</sup>
                </td>
                <td>None</td>
                <td>None</td>
                <td>None</td>
                <td>0.50%</td>
              </tr>
              <tr>
                <td className="fw-6">
                  Ongoing Annual Stockholder Servicing Fee<sup>6</sup>
                </td>
                <td>None</td>
                <td>0.25%</td>
                <td>0.85%</td>
                <td>
                  0.65% financial advisor
                  <br />
                  0.20% dealer
                </td>
              </tr>
            </table>
          </div>
        </div>
      )}
    </section>
  );
};

export default ShareClassFees;
